import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from '@guildeducationinc/recess';
import { useLocale } from 'pe-core-frontend';
import { getBreakdownIndicatorColor } from '../../utils/colorUtils';
import styles from './FundingBreakdownItem.module.scss';
import { generateFundingCardTitle } from '../FundingCard/utils/titleUtils';
const getLayoutClass = (count) => {
    if (count >= 3)
        return styles.threeColumns;
    if (count === 2)
        return styles.twoColumns;
    return styles.oneColumn;
};
export const FundingBreakdownItem = ({ fundingOverview }) => {
    const { formatCurrency, t } = useLocale();
    const ruleGroups = fundingOverview?.ruleGroups || [];
    const items = useMemo(() => {
        return ruleGroups.map(ruleGroup => {
            const spentAmount = Number(ruleGroup.totalRequested || 0);
            const limitAmount = Number(ruleGroup.limitForPeriod || 0);
            return {
                key: ruleGroup.ruleId,
                title: generateFundingCardTitle(ruleGroup.programs || []),
                spentAmount,
                limitAmount,
                currency: ruleGroup.currency || 'USD',
            };
        });
    }, [ruleGroups]);
    const rootLayoutClass = getLayoutClass(ruleGroups.length);
    return (_jsx("div", { className: `${styles.breakdownGrid} ${rootLayoutClass}`, children: items.map((item, index) => (_jsxs("div", { className: styles.breakdownItem, children: [_jsxs("div", { className: styles.breakdownHeader, children: [_jsx("div", { className: `${styles.categoryIndicator} ${getBreakdownIndicatorColor(index, ruleGroups.length)}` }), _jsx(Typography, { variant: 'body1', className: styles.breakdownTitle, children: item.title })] }), _jsxs("div", { className: styles.breakdownDetails, children: [_jsxs(Typography, { variant: 'body2', className: styles.breakdownAmount, children: [formatCurrency(item.spentAmount, item.currency, true, true), ' ', _jsx("span", { className: styles.breakdownLabel, children: t('spent & requested') })] }), _jsxs(Typography, { variant: 'body2', className: styles.breakdownAmount, children: [formatCurrency(item.limitAmount, item.currency, true, true), ' ', _jsx("span", { className: styles.breakdownLabel, children: t('limit') })] })] })] }, item.key))) }));
};
